export default {
  careerDescription: { mt: { xs: 3, lg: 5 } },
  statBox: { width: { xs: '100%', lg: '930px' } },
  imageBox: { mt: { xs: 0, lg: -8 }, mb: { xs: 0, lg: -3 } },
  companiesTitle: {
    fontSize: { xs: 18, md: 22 },
    mb: 4,
    mt: { xs: 5, lg: 7.5 },
  },
};
